module.exports = __webpack_public_path__ + "static/media/SWSCRC6-33.232e2179.mp3";